export default __webpack_public_path__ + "1aa3c1cddf5f60360a6dea40bee1f6e8.png";